"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoEncodingConnectionHealthPolicyName = void 0;
/**
 * Video encoding connection policy names. The policy name is used in MonitorTask
 * to determine video codec degradation reason and report metrics accordingly.
 */
var VideoEncodingConnectionHealthPolicyName;
(function (VideoEncodingConnectionHealthPolicyName) {
    VideoEncodingConnectionHealthPolicyName["VideoEncodingCpuHealth"] = "Video Encoding CPU Health";
    VideoEncodingConnectionHealthPolicyName["VideoEncodingFramerateHealth"] = "Video Encoding framerate Health";
    VideoEncodingConnectionHealthPolicyName["VideoConcurrentSendersHealth"] = "Video Concurrent Senders Health";
})(VideoEncodingConnectionHealthPolicyName = exports.VideoEncodingConnectionHealthPolicyName || (exports.VideoEncodingConnectionHealthPolicyName = {}));
exports.default = VideoEncodingConnectionHealthPolicyName;
//# sourceMappingURL=VideoEncodingConnectionHealthPolicyName.js.map